/* ============================================================
   SPICY DADDA, shared site behaviour for standalone pages
   (hamburger menu + footer newsletter). No warp/carousel here.
   ============================================================ */
(() => {
  'use strict';

  /* ---- Global hamburger menu ---- */
  const menuToggle = document.getElementById('menuToggle');
  const menuClose  = document.getElementById('menuClose');
  const appMenu    = document.getElementById('appMenu');

  const setMenu = (open) => {
    if (!appMenu) return;
    appMenu.classList.toggle('is-open', open);
    appMenu.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  };
  if (menuToggle) menuToggle.addEventListener('click', () => setMenu(true));
  if (menuClose)  menuClose.addEventListener('click', () => setMenu(false));
  if (appMenu) appMenu.addEventListener('click', (e) => { if (e.target === appMenu) setMenu(false); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') setMenu(false); });

  /* ---- Footer newsletter, acknowledge the signal ---- */
  const news = document.getElementById('footerNews');
  if (news) {
    news.addEventListener('submit', (e) => {
      e.preventDefault();
      const btn = news.querySelector('.footer-news__btn');
      const input = news.querySelector('.footer-news__input');
      if (input) { input.value = ''; input.placeholder = 'Frequency locked ✓'; input.disabled = true; }
      if (btn) { btn.textContent = 'Joined'; btn.disabled = true; }
    });
  }

  /* ============================================================
     PHASE 1 POLISH, global footer restructure
     (mirrors script.js / pdp.js so the change is site-wide
     without editing the shared footer markup in each HTML file)
     ============================================================ */
  const footer = document.querySelector('.site-footer');
  if (footer) {
    const cols = footer.querySelectorAll('.footer-col');
    const social = footer.querySelector('.footer-social');

    const nlCol = cols[0];
    if (nlCol) {
      const head = nlCol.querySelector('.footer-col__eyebrow');
      if (head) {
        head.textContent = window.matchMedia('(min-width: 1024px)').matches
          ? 'Join our mailing list for 15% off your next order.'
          : 'Join our mailing list for 15% off your next order';
        head.classList.add('footer-news__headline');
      }
      const body = nlCol.querySelector('.footer-col__body');
      if (body) body.remove();
      const form = nlCol.querySelector('.footer-news');
      if (form && social) form.insertAdjacentElement('afterend', social);
    }

    // Shipping & Operations column removed entirely (per punch-list).
    if (cols[1]) cols[1].remove();

    if (cols[2]) cols[2].remove();
  }

  /* ============================================================
     PHASE 2, RELATED CAROUSEL (arrows + drag), same feel as PDP.
     Runs only where a #relatedGrid exists (e.g. the About page).
     ============================================================ */
  const relGrid = document.getElementById('relatedGrid');
  if (relGrid) {
    const deck = relGrid.closest('.pdp-related__deck');
    const relPrev = deck && deck.querySelector('.deck-nav--prev');
    const relNext = deck && deck.querySelector('.deck-nav--next');
    const relPitch = () => relGrid.children.length > 1
      ? relGrid.children[1].offsetLeft - relGrid.children[0].offsetLeft
      : relGrid.clientWidth;
    const stepTo = (target) => {
      relGrid.scrollLeft = Math.max(0, Math.min(relGrid.scrollWidth - relGrid.clientWidth, target));
    };
    if (relPrev) relPrev.addEventListener('click', () => stepTo(relGrid.scrollLeft - relPitch()));
    if (relNext) relNext.addEventListener('click', () => stepTo(relGrid.scrollLeft + relPitch()));

    const placeArrows = () => {
      const frame = relGrid.querySelector('.rel-card__frame');
      if (!frame || !deck || !relPrev || !relNext) return;
      const top = frame.getBoundingClientRect().top - deck.getBoundingClientRect().top + frame.offsetHeight / 2;
      relPrev.style.top = relNext.style.top = top + 'px';
    };
    placeArrows();
    window.addEventListener('resize', placeArrows);
    relGrid.querySelectorAll('img').forEach((img) => { if (!img.complete) img.addEventListener('load', placeArrows, { once: true }); });

    let down = false, startX = 0, startScroll = 0, moved = false;
    relGrid.addEventListener('mousedown', (e) => { down = true; moved = false; startX = e.clientX; startScroll = relGrid.scrollLeft; });
    window.addEventListener('mousemove', (e) => { if (!down) return; const dx = e.clientX - startX; if (Math.abs(dx) > 4) moved = true; relGrid.scrollLeft = startScroll - dx; });
    window.addEventListener('mouseup', () => { down = false; });
    relGrid.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
  }

  /* ============================================================
     PHASE 2, ABOUT PAGE: random UFO flybys.
     A UFO crosses the screen at a random vertical position, then
     repeats every 20s. Honors prefers-reduced-motion.
     ============================================================ */
  const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (document.querySelector('.about') && !reduceMotion) {
    const launchUFO = () => {
      const ufo = document.createElement('img');
      ufo.src = window.themeAssets ? window.themeAssets.ufoFull : '';
      ufo.className = 'ufo-flyby';
      ufo.alt = '';
      ufo.setAttribute('aria-hidden', 'true');

      const topVh = 6 + Math.random() * 72;        // random vertical position
      const leftToRight = Math.random() < 0.5;     // random direction
      const dur = 7000 + Math.random() * 5000;     // 7–12s crossing
      ufo.style.top = topVh + 'vh';
      document.body.appendChild(ufo);

      const fromX = leftToRight ? '-25vw' : '125vw';
      const toX   = leftToRight ? '125vw' : '-25vw';
      const tilt  = leftToRight ? 8 : -8;
      const anim = ufo.animate([
        { transform: `translateX(${fromX}) rotate(${-tilt}deg)`, opacity: 0 },
        { transform: `translateX(${leftToRight ? '-10vw' : '110vw'}) rotate(${-tilt}deg)`, opacity: 1, offset: 0.12 },
        { transform: `translateX(${leftToRight ? '110vw' : '-10vw'}) rotate(${tilt}deg)`, opacity: 1, offset: 0.88 },
        { transform: `translateX(${toX}) rotate(${tilt}deg)`, opacity: 0 }
      ], { duration: dur, easing: 'linear' });
      anim.onfinish = () => ufo.remove();
    };

    launchUFO();                       // one right away
    setInterval(launchUFO, 20000);     // then every 20s
  }

  // Contact page's tractor-beam submit sequence lives in contact-form.js,
  // wired against the real Shopify {% form 'contact' %} submission.
})();
